
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { FeatureContext } from '../../../Context';
import Orders from "./Orders";
import { ChakraProvider } from '@chakra-ui/react';
import { Error } from '../../../components/error/Error';
import { getOrders } from '../Services';
import { NoDataFound } from '../../../ErrorType';

const Index = () => {
  const [mounted, setMounted] = useState(false);

  const [state, setState] = useState({
    loading: false,
    dataloading: false,
    error: '',
    orders: {},
    showFilters: false,
    showChips: true,
    showCharts: false,
    filters: {
      startDate: DateTime.now().minus({ month: 6 }).toISODate(),
      endDate: DateTime.now().toISODate()
    },
    setOrders: (value) => setState(prevState => ({ ...prevState, orders: value })),
    setFilters: (name, value) => setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value
      }
    })),
    removeFilters: (name, code) => {
      setState(prevState => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: prevState.filters[name].filter((value) => value.value !== code)
        }
      }))
    },
    setFiltersDate: (name, value) => setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: DateTime.fromJSDate(value).toISODate()
      }
    })),
    setLoading: {
      on: () => setState(prevState => ({ ...prevState, loading: true })),
      off: () => setState(prevState => ({ ...prevState, loading: false })),
    },
    setDataloading: {
      on: () => setState(prevState => ({ ...prevState, dataloading: true })),
      off: () => setState(prevState => ({ ...prevState, dataloading: false })),
    },
    toggleFilters: () => setState(prevState => ({
      ...prevState,
      showFilters: !prevState.showFilters,
      showChips: !prevState.showChips
    })),
    toggleCharts: () => setState(prevState => ({
      ...prevState,
      showCharts: !prevState.showCharts,
    })),
    setFilteredOrders: (values) => setState(prevState => ({ ...prevState, filtereOrders: values })),
    setError: (value) => setState(prevState => ({ ...prevState, error: value })),
  });

  useEffect(() => {

    if (!mounted) {
      state.setLoading.on()
    } else {
      state.setDataloading.on();
    };

    const filters = Object.entries(state.filters).reduce((obj, filter) => obj = {
      ...obj,
      [filter[0]]:
        (filter[1] instanceof Array) ?
          filter[1].reduce((arr, value) => arr = [...arr, value.value], []) :
          filter[1]
    }, {});

    getOrders(filters)
      .then(data => {
        state.setOrders(data);
      })
      .catch(error => {
        if (error.code !== 404) {
          state.setError(error);
        }
        state.setOrders({});
      })
      .finally(_ => {
        if (!mounted) {
          state.setLoading.off();
          setMounted(true);
        } else {
          state.setDataloading.off();
        }
      });
  }, [state.filters]);

  const render = () => {
    if (state.error) {
      return <Error error={state.error} />
    } else {
      return <Orders />
    }
  }

  return <ChakraProvider>
    <FeatureContext.Provider value={state}>
      {render()}
    </FeatureContext.Provider>
  </ChakraProvider>

}

export { Index }
